import React from "react";
import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/site";

export default function FloatingWhatsApp() {
  return (
    <a
      data-testid="floating-whatsapp-btn"
      href={waLink()}
      target="_blank"
      rel="noreferrer"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-70 animate-ping" />
      <span className="relative flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebd5a] text-white pl-4 pr-5 py-3 rounded-full shadow-2xl shadow-emerald-500/30 hover:shadow-emerald-500/50 transition-all hover:scale-105">
        <MessageCircle className="w-5 h-5" strokeWidth={2.4} />
        <span className="hidden sm:inline font-semibold text-sm">Fale conosco</span>
      </span>
    </a>
  );
}
